<template>
  <div class="testright">

    <div style="position: fixed;right: 30px;" v-if="showcomputer"><computer @handleClose="handleClose"></computer></div>
    <div v-if="showloading" style="position: fixed;width: 100%;left: 0;top:0;height: 100vh;background: rgba(34, 34, 34, 0.5);align-items: center;justify-content: center;display: flex;">
      <img src="../assets/img/loading.gif">
    </div>
  	<div class="btnlist">
  		<span class="btn" :class="{'active':status==-1}" @click="handleTabStatus(-1)">不限题型</span>
  		<span class="btn" :class="{'active':status==1}" @click="handleTabStatus(1)">单项选择题</span>
  		<span class="btn" :class="{'active':status==2}" @click="handleTabStatus(2)">多项选择题</span>
      <span class="btn" :class="{'active':status==0}" @click="handleTabStatus(0)">判断题</span>
      <span class="btn" :class="{'active':status==3}" @click="handleTabStatus(3)">计算题</span>
  		<span class="btn" :class="{'active':status==4}" @click="handleTabStatus(4)">综合题</span>
      <span class="flex1"></span>
      <span class="btn" style="cursor: pointer;color: #4fa7ff;margin-right: 0;" @click="handleBack()"><<返回</span>
  	</div>
  	<div class="border" style="border: none;" v-if="list.length>0">
  		<div class="topborder">
        <div class="flex">
        	<span class="font18" style="font-weight: bold;">第{{activeIndex}}题
          <template v-if="examObj.questionStatus==0">
            【判断题】
          </template>
          <template v-if="examObj.questionStatus==1">
            【单项选择题】
          </template>
          <template v-if="examObj.questionStatus==2">
            【多项选择题】
          </template>
          <template v-if="examObj.questionStatus==3">
            【计算题】
          </template>
          <template v-if="examObj.questionStatus==4">
            【综合题】
          </template>
          </span>
        	<span class="flex1"></span>
        	<span class="btns" v-if="activeIndex>1" @click="handlePrev()">
        		<img src="../assets/img/prev.png" >
        		<span class="font14">上一题</span>
        	</span>
        	<span class="btns" v-if="activeIndex!=list.length" @click="handleNext()">

        		<span class="font14">下一题</span>
        		<img src="../assets/img/next.png" style="margin-left: 5px;margin-right: 0;" >
        	</span>
        	<span class="btns" @click="handleAsk()">
        		<img src="../assets/img/doubt.png" >
        		<span class="font14">试题答疑</span>
        	</span>
        	<span class="btns" @click="handleCollect(examObj.collTag)">
        		<img src="../assets/img/collected.png" v-if="examObj.collTag" >
            <img src="../assets/img/remark.png" v-else >
        		<span class="font14">收藏</span>
        	</span>
        </div>
        <div class="line">

        </div>
        <div class="" style="padding: 20px 10px;" v-if="examObj.questionStatus==0">
        	<div class="flex">
        		<span class="flex1" style="line-height: 2.5;" v-html="examObj.questionTitle"></span>

        	</div>
        	<div class="questionlist judge" v-for="item,index in examObj.optionList">
        		<span class="letters " :class="{'done':childIndex==0 ||item.selected}" @click="handleChooseThis(0)" v-if="index==0">✔</span>
            <span class="letters" :class="{'done':childIndex==1 ||item.selected}" @click="handleChooseThis(1)"  v-if="index==1">✔</span>
            <span class="letters" :class="{'done':childIndex==2 ||item.selected}" @click="handleChooseThis(2)"  v-if="index==2">✔</span>
            <span class="letters" :class="{'done':childIndex==3 ||item.selected}" @click="handleChooseThis(3)" v-if="index==3">✔</span>
            <span class="letters" :class="{'done':childIndex==4 ||item.selected}" @click="handleChooseThis(4)"  v-if="index==4">✔</span>
            <span class="letters" :class="{'done':childIndex==5 ||item.selected}" @click="handleChooseThis(5)"  v-if="index==5">✔</span>
            <span class="flex1" v-html="item.optionTitle" style="line-height: 2.5;"></span>

        	</div>


        </div>
        <div class="" style="padding: 20px 10px;" v-if="examObj.questionStatus==1">
        	<div class="flex">
        		<span class="flex1" style="line-height: 2.5;" v-html="examObj.questionTitle"></span>

        	</div>
        	<div class="questionlist" v-for="item,index in examObj.optionList">
        		<span class="letters circle" :class="{'done':childIndex==0 ||item.selected}" @click="handleChooseThis(0)" v-if="index==0">A</span>
            <span class="letters circle" :class="{'done':childIndex==1 ||item.selected}" @click="handleChooseThis(1)"  v-if="index==1">B</span>
            <span class="letters circle" :class="{'done':childIndex==2 ||item.selected}" @click="handleChooseThis(2)"  v-if="index==2">C</span>
            <span class="letters circle" :class="{'done':childIndex==3 ||item.selected}" @click="handleChooseThis(3)" v-if="index==3">D</span>
            <span class="letters circle" :class="{'done':childIndex==4 ||item.selected}" @click="handleChooseThis(4)"  v-if="index==4">E</span>
            <span class="letters circle" :class="{'done':childIndex==5 ||item.selected}" @click="handleChooseThis(5)"  v-if="index==5">F</span>
            <span class="flex1" v-html="item.optionTitle" style="line-height: 2.5;"></span>

        	</div>


        </div>
        <div class="" style="padding: 20px 10px;" v-if="examObj.questionStatus==2">
        	<div class="flex">
        		<span class="flex1" v-html="examObj.questionTitle"></span>

        	</div>
        	<div class="questionlist" v-for="item,index in examObj.optionList">
        		<span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(0)"  v-if="index==0">A</span>
        	  <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(1)"  v-if="index==1">B</span>
        	  <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(2)"  v-if="index==2">C</span>
        	  <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(3)"  v-if="index==3">D</span>
        	  <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(4)"  v-if="index==4">E</span>
        	  <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(5)"  v-if="index==5">F</span>
        	  <span class="flex1" v-html="item.optionTitle" style="line-height: 2.5;"></span>
        	</div>

        </div>
        <template  v-if="examObj.questionStatus==3 || examObj.questionStatus==4">
          <div class="zonghe" style="padding: 20px 30px;line-height: 2.5;" v-html="examObj.questionTitle">
          </div>
          <div class="line">

          </div>
          <div class="" style="padding: 10px 10px;">
          	<div class="font14" style="color: #999;">
          		本大题共{{examObj.synthesizeList.length}}小题
          	</div>
          </div>
          <div class="" style="height: 319px;overflow-y: auto;">
          		<template v-for="item,index in examObj.synthesizeList">
          		  <div class="list" style="margin-top: 25px;">
          		  	<div class="quetsiontitle" v-html="item.questionTitle">

          		  	</div>
          		  	<template v-if="item.questionStatus== 3|| item.questionStatus==4">
          		  	  <textarea rows="" cols="" placeholder="请输入您的解答"></textarea>
          		  	</template>
                  <template v-if="item.questionStatus==1">
                    <div class="questionlist" v-for="voo,cindex in item.optionList">
                    	<span class="letters" :class="{'done':voo.selected}" @click="handleChoose(index,cindex)" v-if="cindex==0">A</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoose(index,cindex)"  v-if="cindex==1">B</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoose(index,cindex)"  v-if="cindex==2">C</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoose(index,cindex)" v-if="cindex==3">D</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoose(index,cindex)"  v-if="cindex==4">E</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoose(index,cindex)"  v-if="cindex==5">F</span>
                      <span v-html="voo.optionTitle" style="line-height: 2.5;"></span>
                      <span class="aui-line"></span>
                    </div>
                  </template>
                  <template v-if="item.questionStatus==2">
                    <div class="questionlist" v-for="voo,cindex in item.optionList">
                    	<span class="letters" :class="{'done':voo.selected}" @click="handleChoosemult(index,cindex)" v-if="cindex==0">A</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoosemult(index,cindex)"  v-if="cindex==1">B</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoosemult(index,cindex)"  v-if="cindex==2">C</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoosemult(index,cindex)" v-if="cindex==3">D</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoosemult(index,cindex)"  v-if="cindex==4">E</span>
                      <span class="letters" :class="{'done':voo.selected}" @click="handleChoosemult(index,cindex)"  v-if="cindex==5">F</span>
                      <span v-html="voo.optionTitle" style="line-height: 2.5;"></span>
                    </div>
                  </template>
                  <template v-if="examObj.answerStatus==1">
                   <div style="color: rgb(79, 167, 255); margin-top: 20px;">答案解析</div>
                   <div v-html="item.questionAnalysis" style="margin-top: 15px;line-height: 2.5;"></div>
                  </template>
          		  </div>
          		</template>
          </div>
        </template>


        <div class="viewanswer" style="margin-left: 30px;" v-if="examObj.answerStatus==-1">
          <span class="btn" @click="handleDone()" v-if="examObj.questionStatus==0">回答完毕</span>
        	<span class="btn" @click="handleDone()" v-if="examObj.questionStatus==1">回答完毕</span>
          <span class="btn" @click="handleMoreDone()" v-if="examObj.questionStatus==2">回答完毕</span>
           <span class="btn" @click="handlemultDone()" v-if="examObj.questionStatus==3 || examObj.questionStatus==4">回答完毕</span>
        </div>
      </div>
  		<div class="viewanswer viewanswers" style="position: relative;padding: 0 15px;" v-if="examObj.answerStatus!=-1 && examObj.questionStatus<3">
  			<div class="" style="margin-top: 20px;margin-left: 15px;">
  				答案解析
  			</div>
  			<div class="lines"></div>
  			<div class="" style="margin-top: 20px;margin-left: 15px;">
  				我的答案：<span style="font-weight: bold;">{{myAnswer}}</span>
  			</div>
        <div class="lines"></div>
  			<div class="" style="margin-top: 20px;margin-left: 15px;">
  				参考答案：<span style="color: #5cb85c;font-weight: bold;">{{rightAnswer}}</span>
  			</div>
        <div class="lines"></div>
        <div class="" style="margin-top: 20px;margin-left: 15px;">
        	参考解析：
        </div>
        <div class="lines"></div>
  			<div class="flex" style="padding-bottom: 15px;margin-left: 10px;">
  				<span style="font-size: 16px;color: #999999;flex:1;line-height: 2.5;" v-html="examObj.questionAnalysis"></span>
  			</div>
  			<img src="../assets/img/pcright.png" style="position: absolute;left: 200px;top: 20px;" v-if="examObj.answerStatus==1" >
        <img src="../assets/img/pcerror.png" style="position: absolute;left: 200px;top: 20px;" v-if="examObj.answerStatus==0" >
  		</div>
    <!--  <div class="lines" v-if="examObj.answerStatus!=-1">

      </div> -->
      <div class="myborder"  v-if="examObj.answerStatus!=-1 && list.length>0">
        <div  v-if="examObj.answerStatus!=-1">
              <div class="btnlist">
                <span class="btn  flex" :class="{'others':noteStatus==2}" @click="handleNoteList(2)">
                  <img src="../assets/img/collect.png" width="20" height="20" style="margin-right: 5px;" v-if="noteStatus==2" />
                  <img src="../assets/img/collect_on.png" width="20" height="20" style="margin-right: 5px;" v-else />
                  他人笔记</span>
                <span class="btn flex" :class="{'others':noteStatus==1}"  @click="handleNoteList(1)">
                  <img src="../assets/img/edit.png" width="20" height="20" style="margin-right: 5px;" v-if="noteStatus==2" />
                  <img src="../assets/img/edit_on.png" width="20" height="20" style="margin-right: 5px;" v-else />
                  我的笔记</span>
                <span class="btn flex" @click="showError=true">
                  <img src="../assets/img/edit.png" width="20" height="20" style="margin-right: 5px;" />
                  纠错</span>
              </div>
        </div>
        <div style="height:1px;background-color: silver;margin:0 -15px;margin-bottom: 15px;"></div>
        <div class="my" v-if="examObj.answerStatus!=-1">
          <template>
           <div class="noteList" v-for="item in noteList">
             <span class="nickname">{{item.nickName}}</span>
             <span class="createTime">{{item.createTime}}</span>
             <div class="content">{{item.content}}:</div>
           </div>
          </template>
          <template  v-if="noteStatus==1">
            <div class="formwrap">
              <textarea value="" placeholder="" v-model="content" />
              <div class="text-right">
                <span class="save" @click="handleSbumitRemark">保存</span>
              </div>
            </div>
          </template>
        </div>
      </div>
  	</div>
    <template v-if="showError">
      <error @closewin="showError=false" :questionId="examObj.questionId"></error>
    </template>
  </div>
</template>

<script>
  import computer from './compute.vue'
  import error from './error.vue'
  export default {
    name: 'Footer',
    components:{
      computer,
      error
    },
    props:{
      list:{
          type:Array,
          default:()=>[]
      },
      status:{
        type:Number,
        default:()=>0
      },
      activeIndex:{
        type:Number,
        default:()=>-1
      },
      questionsStatus:{

        type:String,
        default:()=>-1
      },
      testQuestionsId:{
        type:String,
        default:()=>-1
      },
      showcomputer:{
        type:Boolean,
        default:()=>false
      }
    },
    data () {
      return {
          data:'',
          examObj:{},
          childIndex:-1,//单选索引
          myAnswer:'',
          rightAnswer:'',
          moreList:[],
          showloading:true,
          showError:false,
          content:'',
          noteStatus:2,
          noteList:[]
      }
    },
    methods:{
      handleNoteList(noteStatus){
        this.noteStatus=noteStatus;
        this.getNoteList()
        },
      getNoteList(){
        this.$axios.get(this.$common.questionNote_index+'?questionId='+this.examObj.questionId+'&status='+this.noteStatus).then((res)=>{
              if(res.data.code==1){


                  this.noteList=res.data.data;

              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleSbumitRemark(){
        if(this.content==''){

          alert('请填写笔记内容')
          return
        }
        let data=new FormData();
            data.append('questionId',this.examObj.questionId);
            data.append('content',this.content);
        this.$axios.post(this.$common.questionNote_sub,data).then((res)=>{
              if(res.data.code==1){

                  alert('笔记保存成功')
                  this.content=''
                  this.getNoteList()

              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleBack(){
        this.$router.go(-1)
      },
      handleSave(){
        let data=new FormData();
            data.append('testQuestionsId',this.testQuestionsId);
            data.append('content',JSON.stringify(this.list));
        this.$axios.post(this.$common.testPaper_testQuestionCacheSub,data).then((res)=>{
              if(res.data.code==1){


              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleClose(){
        this.$emit('handleClose')
      },
      getSubmit(){
        let datas=new FormData();
            datas.append('errorQuestionStatus',this.errorQuestionStatus);
            datas.append('testQuestionsId',this.testQuestionsId);
            datas.append('chapterId',this.testQuestionsId);
            let obj=this.list[this.activeIndex-1]
            let list=[obj]
            datas.append('testQuestions', JSON.stringify(list));
            datas.append('childQuestionStatus',this.questionsStatus);

        this.$axios.post(this.$common.testPaper_testPaperQuestionSub,datas).then((res)=>{
              if(res.data.code==1){
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleTabStatus(status){   //切换试题类型
          if(this.status==status){
            return;
          }
          this.$emit('tabStatus',status)
      //    this.status=status;
      },
      handleChooseThis(index){  //单选
          if(this.examObj.answerStatus!=-1){
            return;
          }
          this.childIndex=index;
      },
      handlemultDone(){
        this.examObj.answerStatus=1;
      },
      handleDone(){  //单选回答完毕
        this.$forceUpdate()
        if(this.childIndex==-1){
          alert('请选择答案');
          return ;
        }
        this.examObj.optionList[this.childIndex].selected=true;
        if(this.examObj.optionList[this.childIndex].optionAnswerStatus){
              // console.log(55)
              this.examObj.answerStatus=1;


        }
        else{
          this.examObj.answerStatus=0
        }
        this.getSubmit();
        this.handleSave();
        // console.log(this.examObj)
        this.getAnswer();
        this.getNoteList()

      },
      getAnswer(){  //获取答案
        var lettersList=['A','B','C','D','E','F'];
        var myAnswer=[];
        var rightAnswer=[];
        this.examObj.optionList.forEach((item,index)=>{

            if(item.selected){

              myAnswer.push(lettersList[index])
            }
            if(item.optionAnswerStatus){

              rightAnswer.push(lettersList[index])
            }
        })

        this.myAnswer=myAnswer.join();
        this.rightAnswer=rightAnswer.join();
      },
      handleChooseMore(index){ //多选
        this.$forceUpdate()
        this.moreList[index]=!this.moreList[index];

      },
      handleMoreDone(){  //多选完成

          var list=this.moreList.filter((item)=>{
               return item
          })
          if(list.length==0){

            alert('请选择答案')
            return;
          }
          this.moreList.forEach((item,index)=>{
              if(item){
                  this.examObj.optionList[index].selected=true;
              }
          })
          var answerStatus=this.examObj.optionList.every((item)=>{
                           // console.log(item.optionAnswerStatus,item.selected)
                    return item.optionAnswerStatus==Boolean(item.selected)
              });
               console.log(answerStatus)
          this.examObj.answerStatus=answerStatus?1:0;
          this.handleSave();
          this.getSubmit();
          this.getAnswer();
          this.getNoteList()
      },
      handlePrev(){
        this.$emit('handlePrev')
      },
      handleNext(){
        this.$emit('handleNext')
      },
      handleAsk(){

          this.$emit('quesitonList')
       },
       handleCollect(tag){
         let data=new FormData();
             data.append('questionId',this.examObj.questionId);
             data.append('errorQuestionStatus',this.questionsStatus);
             data.append('testQuestionsId',this.testQuestionsId);
             data.append('chapterId',this.testQuestionsId);
         this.$axios.post(this.$common.testPaper_removeCollQuestion,data).then((res)=>{
               if(res.data.code==1){
                  this.examObj.collTag=!this.examObj.collTag;
               }
               else {
                 alert(res.data.msg)
               }
         })
       },
       handleChoosemult(index,cindex){  //综合体多选
          this.$forceUpdate();
          this.examObj.synthesizeList[index].optionList[cindex].selected=!this.examObj.synthesizeList[index].optionList[cindex].selected
       },
       handleChoose(index,cindex){   //综合体单选
          this.$forceUpdate();
          this.examObj.synthesizeList[index].optionList.forEach((item,index)=>{

                    if(index==cindex){
                      item.selected=true;
                    }
                    else {
                      item.selected=false;
                    }
          })
       }
    },
    created(){

    },
    watch:{
      activeIndex(val){
        this.$forceUpdate()
        this.examObj=this.list[val-1];
        console.log(this.examObj)
        this.childIndex=-1;
        this.moreList=this.examObj.optionList.map(()=>{
          return false
        })
        this.getAnswer();
        this.noteList=[];
        this.noteStatus=2;
      },
      list(val){
          if(val.length>0){
            this.examObj=this.list[this.activeIndex-1];
            this.showloading=false
          }
          else {
            this.examObj={}
          }
      }
    },
    computed:{
        errorQuestionStatus(){
          if(this.questionsStatus==1){

              return 1
          }
          if(this.questionsStatus==2){

              return 2
          }
          if(this.questionsStatus==3){

              return 3
          }
          if(this.questionsStatus==4){

              return 4
          }
          if(this.questionsStatus==5){

              return 4
          }
          if(this.questionsStatus==6){

              return 5
          }
          if(this.questionsStatus==7){

              return 5
          }
        }
    }
  }
</script>

<style scoped>
  .btnlist {
  	display: flex;
    margin-bottom: 20px;
    border: 1px solid #f8f8f8;
    margin: -1px;
    padding-bottom: 15px;
    align-items: center;

  }
  .btnlist .btn {
  	font-size: 14px;
  	width: 120px;
  	height: 40px;
  	text-align: center;
  	background-color: #fff;
  	border: 1px solid silver;
  	line-height: 40px;
  	margin-right: 15px;
    color: #333;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }
  .btnlist .active {
  	background-color: #4fa7ff;
  	border-color: #4fa7ff;
  	color: #fff;
  }
  .btnlist .others {
    background: #02756E;
    color: #fff;
  }
  .border {


  }
  .questionlist {
  	margin-top: 20px;
    position: relative;
    display: flex;
  }
  .questionlist::after {

    content: '';
    position: absolute;
    height: 1px;
    background-color: #ccc;
    width: 100%;
    left: 0;
    bottom: -10px;
    opacity: .3;
  }
  .letters {
  	width: 30px;
  	height: 30px;
  	border: 1px solid #999999;
  	display: inline-block;
  	text-align: center;
  	line-height: 30px;
  	margin-right: 15px;
  	border-radius: 4px;
    cursor: pointer;
  }
  .circle  {
    border-radius: 100%;
  }
  .done {
      border-color: #4fa7ff;
      color: #4fa7ff;
  }
  .viewanswer .btn {
  	width: 130px;
  	height: 50px;
  	line-height: 50px;
  	text-align: center;
  	color: #fff;
  	background-color: #4fa7ff;
  	display: inline-block;
  	margin-top: 15px;
    cursor: pointer;
  }
  .line {
  	height: 1px;
  	background-color: #eee;
  	margin: 15px -20px;
  }
  .lines {
    height: 1px;
    background-color: silver;
    margin: 15px -15px;
  }
  .btns {
  	border: 1px solid silver;
  	display: flex;
  	align-items: center;
  	margin-left: 15px;
    cursor: pointer;
    background-color: #fff;
    width: 120px;
    height: 40px;
    justify-content: center;
  }
  .btns.active {

        background-color: #4fa7ff;
        border-color: #4fa7ff;
  }
  .btns.active span {
    color: #FFFFFF !important;
  }
  .btns img {
  	margin-right: 5px;
  }
  textarea {
  	height: 180px;
  	width: 90%;
  	border: none;
  	background-color: #f5f5f5;
  	margin: 15px 0;
  	padding: 15px;
  	outline: none;
  	border-radius: 4px;
  }
  .judge .letters {
    color: #F8F8F8;
  }
  .judge .done {
    color: #4fa7ff;
  }
  .formwrap textarea {
    background-color: #fff;
    width: 100%;
    padding: 15px;
    margin: -15px;
    border: 1px solid silver;
  }
  .save {
    color: #FFFFFF;
        background-color: #02756E;
        border-color: #02756E;
        display: inline-block;
        padding: 6px 20px;
        margin-top: 35px;
        margin-right: -15px;
        cursor: pointer;
  }
  .formwrap {
    padding: 15px;
  }
  .noteList {
    border: 1px solid silver;
    margin-bottom: -1px;
    padding: 15px;
  }
  .createTime {
    color: #999;
  }
  .noteList .content {
    margin-top: 10px;
  }
  .myborder {
    border: 1px solid silver;
    padding: 15px;
    margin-top: 15px;
  }
  .viewanswers {
    border: 1px solid silver;
    padding: 15px;
    margin-top: 15px;
  }
  .topborder {
    border: 1px solid silver;
    padding: 15px;
    margin-top: 15px;
  }
  .flex1 {
    margin-top: -5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/testright.vue